
import SpaceShareSettingsService from './SpaceShareSettingsService';

export { default } from './SpaceShareSettingsService';
export const spaceShareSettingsService = new SpaceShareSettingsService();